export default __webpack_public_path__ + "static/media/background.f4e8b378.svg";